/**
 * Shared 24h session-window helper. The WA Cloud API only lets a business
 * send freeform messages within 24h of the customer's last inbound. After
 * that, only approved templates are allowed.
 *
 * Both the chat-list row dot (ChatRow) and the thread-header avatar dot
 * (Thread) read from here so they always agree. The composer disable
 * banner in Thread.js also derives from the same source via
 * _sessionWindowStatus().
 */

export const SESSION_WINDOW_HOURS = 24;

/**
 * Returns one of:
 *   - 'open'    — last inbound within 24h; freeform sends allowed
 *   - 'closed'  — last inbound >24h ago; customer is unreachable until they reply
 *   - 'unknown' — no inbound timestamp; render nothing (don't block, don't mislead)
 */
export function sessionKind(lastInboundTs) {
  if (!lastInboundTs) return 'unknown';
  const ageSec = Math.floor(Date.now() / 1000) - lastInboundTs;
  return ageSec < SESSION_WINDOW_HOURS * 3600 ? 'open' : 'closed';
}
